import React, { Component } from 'react';
import { Route, Switch } from "react-router";
import { Layout } from './components/Layout';
import { Home } from './components/Home';
import { FetchData } from './components/FetchData';
import { Counter } from './components/Counter';
import AuthorizeRoute from './components/api-authorization/AuthorizeRoute';
import ApiAuthorizationRoutes from './components/api-authorization/ApiAuthorizationRoutes';
import { ApplicationPaths } from './components/api-authorization/ApiAuthorizationConstants';
import { PaymentPage } from './components/PaymentSystem/PaymentPage';
import { PaymentSubmissionSuccess } from './components/PaymentSystem/PaymentSubmissionSuccess';
import { BookingRequest } from './components/BookingRequest/BookingRequest';
import { BookingQuote } from './components/BookingRequest/BookingQuote';
import { SubmissionSuccess } from './components/BookingRequest/SubmissionSuccess';
import { SubmissionError } from './components/BookingRequest/SubmissionError';
import { NotFound } from "./components/NotFound";

import './custom.css'

export default class App extends Component {
  static displayName = App.name;

  render () {
    return (
      <Layout>
        <Switch>
          <Route path='/BookingRequest' component={BookingRequest} />
          <Route path='/BookingQuote' component={BookingQuote} />
          <Route path='/Payment' component={PaymentPage} />
          <Route path='/PaymentSubmissionSuccess' component={PaymentSubmissionSuccess} />
          <Route path='/SubmissionSuccess' component={SubmissionSuccess} />
          <Route path='/SubmissionError' component={SubmissionError} />
          <Route component={NotFound} />
        </Switch>
      </Layout>
    );
  }
}